import { Error, Success, Confirm, Info } from './alert';

export const MyAlert = {
  Error,
  Success,
  Confirm,
  Info,
};
